import { Component } from '@theme/component';

class SimucubeNewsArticles extends Component {
  requiredRefs = ['grid'];

  #frame = null;

  #touchStartX = 0;

  #touchStartY = 0;

  #touchAxis = null;

  connectedCallback() {
    super.connectedCallback();
    this.refs.grid.addEventListener('scroll', this.#queueUpdate, { passive: true });
    this.refs.grid.addEventListener('touchstart', this.#onTouchStart, { passive: true });
    this.refs.grid.addEventListener('touchmove', this.#onTouchMove, { passive: false });
    window.addEventListener('resize', this.#queueUpdate);
    this.#update();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.refs.grid.removeEventListener('scroll', this.#queueUpdate);
    this.refs.grid.removeEventListener('touchstart', this.#onTouchStart);
    this.refs.grid.removeEventListener('touchmove', this.#onTouchMove);
    window.removeEventListener('resize', this.#queueUpdate);
    if (this.#frame) cancelAnimationFrame(this.#frame);
  }

  #onTouchStart = (event) => {
    const touch = event.touches[0];
    if (!touch) return;
    this.#touchStartX = touch.clientX;
    this.#touchStartY = touch.clientY;
    this.#touchAxis = null;
  };

  #onTouchMove = (event) => {
    const touch = event.touches[0];
    if (!touch) return;
    const deltaX = touch.clientX - this.#touchStartX;
    const deltaY = touch.clientY - this.#touchStartY;
    if (!this.#touchAxis) {
      if (Math.abs(deltaX) < 4 && Math.abs(deltaY) < 4) return;
      this.#touchAxis = Math.abs(deltaX) > Math.abs(deltaY) ? 'x' : 'y';
    }
    if (this.#touchAxis !== 'x') return;
    const grid = this.refs.grid;
    const max = grid.scrollWidth - grid.clientWidth;
    if (max <= 0) return;
    const pullingPastStart = grid.scrollLeft <= 0 && deltaX > 0;
    const pullingPastEnd = grid.scrollLeft >= max && deltaX < 0;
    if ((pullingPastStart || pullingPastEnd) && event.cancelable) {
      event.preventDefault();
    }
  };

  #queueUpdate = () => {
    if (this.#frame) return;
    this.#frame = requestAnimationFrame(() => {
      this.#frame = null;
      this.#update();
    });
  };

  #update() {
    const { grid, track, bar } = this.refs;
    if (!track || !bar) return;

    const max = grid.scrollWidth - grid.clientWidth;
    if (max <= 0) {
      bar.style.width = '100%';
      bar.style.transform = 'translateX(0)';
      return;
    }

    const ratio = grid.clientWidth / grid.scrollWidth;
    const thumbWidth = Math.max(track.clientWidth * ratio, 24);
    const progress = grid.scrollLeft / max;
    const offset = progress * (track.clientWidth - thumbWidth);

    bar.style.width = `${Math.round(thumbWidth)}px`;
    bar.style.transform = `translateX(${Math.round(offset)}px)`;
  }
}

if (!customElements.get('simucube-news-articles')) {
  customElements.define('simucube-news-articles', SimucubeNewsArticles);
}
